import { matchPath } from 'react-router-dom';

/**
 * Ordered most-specific first. Used to turn `location.pathname` into support-friendly labels
 * (avoids raw UUIDs in the feedback UI while `page_path` still stores the full path in the DB).
 */
const ROUTE_LABELS = [
  { path: '/player/:playerId/session/:sessionId', label: 'Session performance' },
  { path: '/club/:clubId/tournaments/new', label: 'Create tournament' },
  { path: '/club/:clubId/tournaments/:tournamentId', label: 'Tournament' },
  { path: '/club/:clubId/tournaments', label: 'Tournaments' },
  { path: '/club/:clubId/session-wrapup/:sessionId', label: 'Session wrap-up' },
  { path: '/club/:clubId/session-wrap-up', label: 'Session wrap-up' },
  { path: '/club/:clubId/session/:sessionId', label: 'Session dashboard' },
  { path: '/club/:clubId/sessions/start', label: 'Start session' },
  { path: '/club/:clubId/sessions/review', label: 'Review sessions' },
  { path: '/club/:clubId/sessions/setup/:blockId', label: 'Block sessions' },
  { path: '/club/:clubId/sessions/setup', label: 'Block bookings, series, and templates' },
  { path: '/club/:clubId/sessions', label: 'Plan sessions' },
  { path: '/club/:clubId/league-performance', label: 'League player performance' },
  { path: '/club/:clubId/league-squad', label: 'League squad' },
  { path: '/club/:clubId/payment-tracking', label: 'Payment tracking' },
  { path: '/club/:clubId/session-simulations', label: 'Session simulations' },
  { path: '/club/:clubId/start-session', label: 'Start session' },
  { path: '/club/:clubId/club-settings', label: 'Club settings' },
  { path: '/club/:clubId/settings', label: 'Club admin' },
  { path: '/clubs/:clubId/leaderboard/:gameType', label: 'Leaderboard' },
  { path: '/session/:sessionId', label: 'Session' },
  { path: '/session', label: 'Session' },
  { path: '/club-management/:clubId', label: 'Club management' },
  { path: '/profile/clubs/:clubId/manage', label: 'Profile – club management' },
  { path: '/profile/clubs/:clubId/performance', label: 'Profile' },
  { path: '/profile/clubs/:clubId/h2h', label: 'Profile' },
  { path: '/profile/clubs/:clubId/partnerships', label: 'Profile' },
  { path: '/profile/clubs/:clubId', label: 'Profile – club' },
  { path: '/profile/games', label: 'Profile – my games' },
  { path: '/profile/sessions', label: 'Profile – my sessions' },
  { path: '/profile/matchups', label: 'Profile – matchups' },
  { path: '/profile/head-to-head', label: 'Profile – matchups' },
  { path: '/profile/clubs', label: 'Profile – clubs' },
  { path: '/profile/settings', label: 'Profile – settings' },
  { path: '/profile/overview', label: 'Profile' },
  { path: '/profile', label: 'Profile' },
  { path: '/upcoming-sessions', label: 'Upcoming sessions' },
  { path: '/create-club', label: 'Create club' },
  { path: '/club-analysis', label: 'Club analysis' },
  { path: '/private-sessions', label: 'Private sessions' },
  { path: '/release-notes', label: 'Release notes' },
  { path: '/matchmaking-info', label: 'Matchmaking info' },
  { path: '/clubs', label: 'Find clubs' },
  { path: '/profile-old', label: 'Profile (legacy)' },
  { path: '/player-dashboard', label: 'Profile' },
  { path: '/club/:clubId', label: 'Club page' },
  { path: '/clubs/:clubId', label: 'Club page' },
  { path: '/club-admin', label: 'Club admin' },
  { path: '/', label: 'Home' },
];

const FALLBACK_LABEL = 'App page';

/**
 * @param {string} pathname - `location.pathname` (no query string)
 * @returns {string} Human-readable page name for support / UI
 */
export function getFeedbackPageLabel(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return FALLBACK_LABEL;
  }
  const normalized = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  for (const { path, label } of ROUTE_LABELS) {
    if (matchPath({ path, end: true }, normalized)) {
      return label;
    }
  }
  return FALLBACK_LABEL;
}
